import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=9c8409ca&scoped=true&"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=9c8409ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8409ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBreadcrumbs,VBtn,VImg,VTooltip})
